/**
 * 大小适配
 */
export var Fits;
(function (_Fits) {
  function contain(content, container) {
    if (content.width === 0 || content.height === 0) {
      return {
        scale: 1,
        frame: {
          x: 0,
          y: 0,
          width: 0,
          height: 0
        }
      };
    }
    var contentRadio = content.width / content.height;
    var containWidth = container.width;
    var containHeight = container.height;
    var containRadio = containWidth > 0 && containHeight > 0 ? containWidth / containHeight : 0;
    var widthScale = containWidth / content.width;
    var heightScale = containHeight / content.height;
    var scale = contentRadio > containRadio ? widthScale : heightScale;
    var width = content.width * scale;
    var height = content.height * scale;
    return {
      //居中
      frame: {
        x: (containWidth - width) / 2,
        y: (containHeight - height) / 2,
        width: width,
        height: height
      },
      scale: scale
    };
  }
  _Fits.contain = contain;
  function cover(content, container) {
    if (content.width === 0 || content.height === 0) {
      return {
        scale: 1,
        frame: {
          x: 0,
          y: 0,
          width: 0,
          height: 0
        }
      };
    }
    var contentRadio = content.width / content.height;
    var containWidth = container.width;
    var containHeight = container.height;
    var containRadio = containWidth > 0 && containHeight > 0 ? containWidth / containHeight : 0;
    var widthScale = containWidth / content.width;
    var heightScale = containHeight / content.height;
    var scale = contentRadio > containRadio ? heightScale : widthScale;
    var width = content.width * scale;
    var height = content.height * scale;
    return {
      //居中
      frame: {
        x: (containWidth - width) / 2,
        y: (containHeight - height) / 2,
        width: width,
        height: height
      },
      scale: scale
    };
  }
  _Fits.cover = cover;
})(Fits || (Fits = {}));